// src/components/campaignSchedule/ScheduleInfo.jsx
import Wrapper from '../../assets/wrappers/JobInfo';

/**  אייקון + טקסט קצר להצגה בכרטיס תזמון */
const ScheduleInfo = ({ icon, text, tooltip }) => {
  return (
    <Wrapper>
      <span className='job-icon' title={tooltip}>
        {icon}
      </span>
      <span className='job-text'>{text}</span>
    </Wrapper>
  );
};

export default ScheduleInfo;
